import { get, readable, writable } from "svelte/store";
import { ALLOW_USER_ROLES, SERVICE_URL } from "../evironment";
import { User } from "../Model/User";
const _accessToken = writable(null);
const _currentUser = writable(null);
const _loggedIn = writable(false);
const _sessionReady = writable(false);
const accessToken = readable(null, set => _accessToken.subscribe(set));
const currentUser = readable(null, set => _currentUser.subscribe(set));
const loggedIn = readable(false, set => _loggedIn.subscribe(set));
const sessionReady = readable(false, set => _sessionReady.subscribe(set));
loadSession();
async function startSession(accessToken) {
    if (isLoggedIn()) {
        throw new Error('No se puede iniciar sessión mientras otra sesión esté activa.');
    }
    const user = await getUserByAccessToken(accessToken);
    localStorage.setItem('current_user', JSON.stringify(user.getState()));
    localStorage.setItem('accessToken', accessToken);
    _accessToken.set(accessToken);
    _currentUser.set(user);
    _loggedIn.set(true);
}
function endSession() {
    if (!isLoggedIn()) {
        return;
    }
    localStorage.removeItem('current_user');
    localStorage.removeItem('accessToken');
    _currentUser.set(null);
    _loggedIn.set(false);
}
function getCurrentUser() {
    return get(_currentUser);
}
function getAccessToken() {
    return get(_accessToken);
}
function isLoggedIn() {
    return get(_loggedIn);
}
async function getUserByAccessToken(accessToken) {
    const response = await fetch(`${SERVICE_URL}/user`, {
        headers: {
            'X-Access-Token': accessToken
        }
    });
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al obtener el usuario.');
    }
    const userState = await response.json();
    userState.type = userState.type;
    const user = new User(userState);
    if (!ALLOW_USER_ROLES.includes(userState.type.id)) {
        throw new Error('El usuario no tiene permiso para acceder.');
    }
    return user;
}
async function loadSession() {
    try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
            return;
        }
        await startSession(accessToken);
    }
    finally {
        _sessionReady.set(true);
    }
}
export { startSession, endSession, getCurrentUser, getAccessToken, loggedIn, isLoggedIn, currentUser, accessToken, sessionReady, };
